<template>
  <generic-modal
    size
    :title="$t('modifier')"
    icon="code"
    :image="'/images/icons/' + type + '.png'"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <h4 class="ui dividing header">{{ $t("general info") }}</h4>
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("type") }}</label>
            <select
              class="ui dropdown"
              ref="type_dropdown"
              name="type"
              v-model="type"
            >
              <option value>{{ $t("select one") }}</option>
              <option value="js">{{ $t("javascript") }}</option>
              <option value="css">{{ $t("css") }}</option>
            </select>
          </div>
          <div class="field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="name" />
          </div>
        </div>
        <div class="field">
          <div
            class="ui blue labeled icon top left pointing right floated dropdown button"
            ref="dd"
          >
            <i class="wrench icon"></i>
            <span class="text">{{ $t("tools") }}</span>
            <div class="menu">
              <!-- <div class="header">
                <i class="tags icon"></i>
                {{ $t("templates") }}
              </div>
              <div class="header">
                <i class="calendar icon"></i>
                {{ $t("display") }}
              </div> -->
              <div class="item" @click="format">
                <i class="code icon"></i>
                {{ $t("format") }}
              </div>
            </div>
          </div>
          <label for>{{ $t("code") }}</label>
          <editor
            @init="init_code('javascript')"
            v-model="code"
            :lang="lang"
            theme="monokai"
          ></editor>
        </div>

        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import { v4 as uuid } from "uuid";
import Editor from "vue2-ace-editor";
import { js } from "js-beautify";

export default {
  components: {
    "generic-modal": GenericModal,
    editor: Editor,
  },
  computed: {},
  props: { modifier: Object },
  data() {
    return {
      type: "code",
      name: "",
      code: "",
      lang: "javascript",
      editor: undefined,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          let modif = {
            uuid: vm.$props.modifier.uuid || uuid(),
            type: vm.type,
            name: vm.name,
            code: vm.code,
          };
          vm.$emit("succedded", modif);
          resolve();
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    init_code() {
      require("brace/mode/javascript");
      require("brace/mode/css");
      require("brace/theme/monokai");
    },
    format() {
      let ress = js(this.code);
      this.code = ress;
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
        code: ["empty"],
      },
    });

    let modif = vm.$props.modifier;
    if (modif.uuid) {
      vm.name = modif.name;
      vm.type = modif.type;
      vm.code = modif.code;
      if (vm.type == "js") {
        vm.lang = "javascript";
      } else if (vm.type == "css") {
        vm.lang = "css";
      }
    }

    window.jQuery(this.$refs.type_dropdown).dropdown({
      onChange(value) {
        if (value == "js") {
          vm.lang = "javascript";
        } else if (value == "css") {
          vm.lang = "css";
        }
      },
    });

    window.jQuery(this.$refs.dd).dropdown();
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {});
  },
};
</script>

<style>
.ace_editor {
  width: 100%;
  min-height: 300px;
}
</style>
